export default __webpack_public_path__ + "static/media/5279111_network_fb_social media_facebook_facebook logo_icon.2e7a13a3.svg";